/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyTypeResponse } from '../../models/company-type-response';

export interface CompanyControllerGetTypes$Params {
}

export function companyControllerGetTypes(http: HttpClient, rootUrl: string, params?: CompanyControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyTypeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, companyControllerGetTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyTypeResponse;
      }>;
    })
  );
}

companyControllerGetTypes.PATH = '/company/types';
